import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import QuantitySelector from '@homeaway/react-quantity';
import {RadioButton, RadioGroup} from '@homeaway/react-form-components';
import AgeSelectGroup from '../AgeSelectGroup/AgeSelectGroup';
import './GuestFields.less';

/**
 * GuestFields
 */
class GuestFields extends Component {
    static propTypes = {
        /** Number of Adults */
        adultsCount: PropTypes.number,
        /** Label for Adults */
        adultsLabel: PropTypes.string,
        /** Label for Increase Adults quantity selector */
        adultsIncreaseLabel: PropTypes.string,
        /** Label for Decrease Adults quantity selector */
        adultsDecreaseLabel: PropTypes.string,
        /** Max Number of Adults */
        adultsMax: PropTypes.number,
        /** Min Number of Adults */
        adultsMin: PropTypes.number,
        /** Number of Children */
        childrenCount: PropTypes.number,
        /** Label for Children */
        childrenLabel: PropTypes.string,
        /** Label for Increase Children quantity selector */
        childrenIncreaseLabel: PropTypes.string,
        /** Label for Decrease Children quantity selector */
        childrenDecreaseLabel: PropTypes.string,
        /** Max Number of Children */
        childrenMax: PropTypes.number,
        /** Min Number of Children */
        childrenMin: PropTypes.number,
        /** Number of Bedrooms */
        bedroomsCount: PropTypes.number,
        /** Label for Bedrooms */
        bedroomsLabel: PropTypes.string,
        /** Label for Increase Bedrooms quantity selector */
        bedroomsIncreaseLabel: PropTypes.string,
        /** Label for Decrease Bedrooms quantity selector */
        bedroomsDecreaseLabel: PropTypes.string,
        /** Max Number of Bedrooms */
        bedroomsMax: PropTypes.number,
        /** Min Number of Bedrooms */
        bedroomsMin: PropTypes.number,
        /** Show bedrooms Quantity Selector false by default */
        showBedroomsOption: PropTypes.bool,
        /** pet Checked false by default */
        petIncluded: PropTypes.bool,
        /** Label for pet Yes */
        petLabel: PropTypes.string,
        /** Label for pet Yes */
        petYesLabel: PropTypes.string,
        /** Label for pet No */
        petNoLabel: PropTypes.string,
        /** Show pet Radio Group false by default */
        showPetOption: PropTypes.bool,
        /** Disable inputs edit, true by default */
        disableInput: PropTypes.bool,
        /** Age Select: List of pre-selected ages for the age selector options */
        ageData: PropTypes.array, // eslint-disable-line react/forbid-prop-types
        /** Age Select: Options for min-age, use of undefined age (when childCount > 0 and no age defined) and its value*/
        ageOptions: PropTypes.shape({
            minVal: PropTypes.number,
            maxVal: PropTypes.number,
            minAge: PropTypes.number,
            useUndefAges: PropTypes.bool,
            undefAgesValue: PropTypes.shape({
                value: PropTypes.string,
                label: PropTypes.string,
                disabled: PropTypes.bool,
            }),
        }),
        /** Age Select: Info text for why age of children is being collected */
        ageSelectSubtitle: PropTypes.string,
        /** Age Select: Title text `How old are the children` */
        ageSelectTitle: PropTypes.string,
        /** Age Select: Show the age select component for itemized ages */
        showAgeSelect: PropTypes.bool,
        /** Show age ranges underneath Adult and Children labels */
        showAgeRanges: PropTypes.bool,
        /** Locale */
        locale: PropTypes.string,
    }

    static defaultProps = {
        adultsCount: 0,
        childrenCount: 0,
        bedroomsCount: 0,
        showBedroomsOption: false,
        petIncluded: false,
        showPetOption: false,
        adultsLabel: 'Adult(s)',
        adultsIncreaseLabel: 'Increase Adults',
        adultsDecreaseLabel: 'Decrease Adults',
        adultsMax: 99,
        adultsMin: 1,
        childrenLabel: 'Children',
        childrenIncreaseLabel: 'Increase Children',
        childrenDecreaseLabel: 'Decrease Children',
        childrenMax: 99,
        childrenMin: 0,
        bedroomsLabel: 'Bedrooms',
        bedroomsIncreaseLabel: 'Increase Bedrooms',
        bedroomsDecreaseLabel: 'Decrease Bedrooms',
        bedroomsMax: 99,
        bedroomsMin: 0,
        petLabel: 'Pets',
        petYesLabel: 'Yes',
        petNoLabel: 'No',
        disableInput: true,
        ageSelectSubtitle: 'This helps us show you a more accurate price',
        ageSelectTitle: 'How old are the children?',
        className: '',
        onChange: () => {}
    }

    /* istanbul ignore next */
    constructor(props) {
        super(props);

        this.handleAdultsUpdate = this.handleUpdate.bind(this, 'adultsCount');
        this.handleChildrenUpdate = this.handleUpdateChildren.bind(this, 'childrenCount');
        this.handleBedroomsUpdate = this.handleUpdate.bind(this, 'bedroomsCount');
        this.handlePetChange = this.handlePetChange.bind(this);
    }

    handleUpdate(key, count) {
        count = parseInt(count, 10);
        this.props.onChange(key, count);
    }

    handleUpdateChildren(key, count) {
        count = parseInt(count, 10);
        this.props.onChange(key, count);
        if (count > 0 && this.props.adultsCount < this.props.adultsMin) {
            this.props.onChange('adultsCount', this.props.adultsMin);
        }
    }

    handlePetChange(event) {
        this.props.onChange(event.target.name, event.target.value === 'true');
    }

    chooseAgeRagangesSublabel(showAgeRanges, subLabel) {
        return showAgeRanges && subLabel || null;
    }

    render() {
        const {
            adultsCount,
            adultsLabel,
            adultsIncreaseLabel,
            adultsDecreaseLabel,
            adultsMax,
            adultsMin,
            childrenCount,
            childrenMax,
            childrenMin,
            childrenLabel,
            childrenIncreaseLabel,
            childrenDecreaseLabel,
            bedroomsCount,
            bedroomsLabel,
            bedroomsIncreaseLabel,
            bedroomsDecreaseLabel,
            bedroomsMax,
            bedroomsMin,
            showBedroomsOption,
            petLabel,
            petIncluded,
            petYesLabel,
            petNoLabel,
            showPetOption,
            showAgeRanges,
            ageData,
            ageOptions,
            ageSelectSubtitle,
            ageSelectTitle,
            onAgeChange,
            showAgeSelect,
            locale,
        } = this.props;

        const formGroupClasses = classNames('form-group guest-fields__form-group', {
            'guest-fields__form-group--age-ranges': showAgeSelect
        });

        const QuantitySelectorLabel = ({label, sublabel}) => {
            const selectorLabelClassName = classNames('quantity-selector-label__label', {
                'quantity-selector-label__de-label': locale.startsWith('de')
            });
            return (
                <div className={'quantity-selector-label '}>
                    <div className={`${selectorLabelClassName}`}>{label}</div>
                    {sublabel &&
                        <div className={'quantity-selector-label__sublabel'}>{sublabel}</div>
                    }
                </div>
            );
        };

        const adultsQuantitySelectorLabel = <QuantitySelectorLabel label={adultsLabel} sublabel={this.chooseAgeRagangesSublabel(showAgeRanges, '(18+)')}/>;
        const childrenQuantitySelectorLabel = <QuantitySelectorLabel label={childrenLabel} sublabel={this.chooseAgeRagangesSublabel(showAgeRanges, '(0-17)')} />;

        return (
            <div>
                <div className="guest-fields" data-wdio="guest-fields">
                    <div className={`${formGroupClasses} guest-fields__form-group--adults`}>
                        <QuantitySelector
                            increaseLabel={adultsIncreaseLabel}
                            decreaseLabel={adultsDecreaseLabel}
                            id="adult-quantity-selector"
                            data-wdio="guest-fields-adult-quantity-selector"
                            min={adultsMin}
                            max={adultsMax}
                            value={adultsCount}
                            onIncrement={this.handleAdultsUpdate}
                            onDecrement={this.handleAdultsUpdate}
                            label={adultsQuantitySelectorLabel}
                            disableInput
                        />
                    </div>
                    <div className={`${formGroupClasses} guest-fields__form-group--children`}>
                        <QuantitySelector
                            increaseLabel={childrenIncreaseLabel}
                            decreaseLabel={childrenDecreaseLabel}
                            id="children-quantity-selector"
                            data-wdio="guest-fields-children-quantity-selector"
                            value={childrenCount}
                            min={childrenMin}
                            max={childrenMax}
                            onIncrement={this.handleChildrenUpdate}
                            onDecrement={this.handleChildrenUpdate}
                            label={childrenQuantitySelectorLabel}
                            disableInput
                        />
                    </div>

                    {showAgeSelect && childrenCount > 0 && (
                        <AgeSelectGroup
                            ageData={ageData}
                            ageOptions={ageOptions}
                            ageSelectSubtitle={ageSelectSubtitle}
                            ageSelectTitle={ageSelectTitle}
                            childrenCount={childrenCount}
                            onAgeChange={onAgeChange}
                        />
                    )}

                    {showBedroomsOption &&
                        <div className={`${formGroupClasses} guest-fields__form-group--bedrooms`}>
                            <QuantitySelector
                                increaseLabel={bedroomsIncreaseLabel}
                                decreaseLabel={bedroomsDecreaseLabel}
                                id="bedrooms-quantity-selector"
                                data-wdio="guest-fields-bedrooms-quantity-selector"
                                value={bedroomsCount}
                                min={bedroomsMin}
                                max={bedroomsMax}
                                onIncrement={this.handleBedroomsUpdate}
                                onDecrement={this.handleBedroomsUpdate}
                                label={bedroomsLabel}
                                disableInput
                            />
                        </div>
                    }

                    {showPetOption &&
                        <div className={`${formGroupClasses} guest-fields__form-group--pet`}>
                            <label htmlFor="guest-fields-pet" className="guest-fields__label">{petLabel}</label>
                            <div className="guest-fields__radio-group">
                                <RadioGroup id="guest-fields__radio-group--pet" name="petIncluded" ariaLabel="pet included?" label="pet">
                                    <RadioButton
                                        className="guest-fields__radio-button--no-pet"
                                        id="guest-fields-no-pet"
                                        inline
                                        value={false}
                                        label={petNoLabel}
                                        checked={!petIncluded}
                                        onChange={this.handlePetChange}
                                        data-wdio="guest-fields-no-pet-quantity-selector"
                                    />
                                    <RadioButton
                                        className="guest-fields__radio-button--has-pet"
                                        id="guest-fields-pet"
                                        value
                                        label={petYesLabel}
                                        inline
                                        checked={petIncluded}
                                        onChange={this.handlePetChange}
                                        data-wdio="guest-fields-pet-quantity-selector"
                                    />
                                </RadioGroup>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default GuestFields;
